/*
 * @Author: Marte
 * @Date:   2017-10-26 10:00:39
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-11-28 16:54:58
 */
"use strict";
angular.module("myResourcesServiceModule", ['subscribeSourceCtrlModule']).
factory("myResourcesService", ["$modal", "trsHttpService", "$q", function($modal, trsHttpService, $q) {
    return {
        subscribeSource: function(folder) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./networkResource/myResources/service/subscribeSource/subscribeSource_tpl.html",
                windowClass: 'subscribeSource',
                backdrop: false,
                controller: "subscribeSourceCtrl",
                resolve: {
                    folder: function() {
                        return folder;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve();
            },function(){
                deffer.reject();
            });
            return deffer.promise;
        },
        /**
         * [setCommonEditingCenter description] 设为常用到采编中心
         */
        setCommonEditingCenter: function(id, name, flag) {
            var deffer = $q.defer();
            var self = this;
            if (flag === 0) {
                var params = {
                    serviceid: "mlf_releasesource",
                    methodname: "cancleMyCustom",
                    CustomIds: id,
                    Custom: name,
                    CustomType: 1
                };
            } else {
                var params = {
                    serviceid: "mlf_releasesource",
                    methodname: "saveMyCustom",
                    CustomId: id,
                    Custom: name,
                    CustomType: 1
                }
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                deffer.resolve();
            }, function() {
                self.setCommonMyResource(id, flag === 0 ? 1 : 0); //设为常用到采编中心失败后的类似回滚操作 
            });
            return deffer.promise;
        },
        /**
         * [setCommonMyResource description] 设为常用 我的资源
         */
        setCommonMyResource: function(id, flag) {
            var deffer = $q.defer();
            var params = {
                typeid: "zyzx",
                serviceid: "subscript",
                modelid: "setCommon",
                id: id,
                is_common: flag //folder.isCommon == 1 ? 0 : 1
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                if (data.result === "success") {
                    deffer.resolve();
                }
            });
            return deffer.promise;
        }
    };
}]);